import { EventEmitter, Injectable } from '@angular/core';
import { UserDataService } from './userData.service';
import { ApiService } from './communications/api.service';
import { ChatMessage } from '../models/chatMessage';
import { chatMessageResponse, chatMessageWithFile } from '../models/chatMessageResponse';
import { Observable } from 'rxjs/internal/Observable';
import { LoggerService } from './loggerService.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private messages: ChatMessage[] = [];
  private participants: Map<number, string> = new Map();
  translate: boolean = false;
  translateLanguage: string = "";
  readonly chatColors = ["#8c8c8c", "#64b4b4", "#f66a57", "#92c746", "#46C7BA", "#f09f29", "#9c27b0", "#3751b5", "#dfe749"];
  readonly chatBackgroundColors = ["#ffffff", "#46c7ba", "#f66a57", "#92c746", "#46C7BA", "#f09f29", "#9c27b0", "#3751b5", "#dfe749"];

  onChatReceived = new EventEmitter<chatMessageWithFile[]>();
  onImageEdited = new EventEmitter<File>();

  constructor(private userDataService: UserDataService, private apiService: ApiService, private logger: LoggerService) {
    console.log("* constructor chat service");
  }

  assignColorsToParticipants(userId: number): void {
    if (!this.userDataService.assetInfo) {
      console.log("assignColorsToParticipants no assetInfo!");
      return;
    }

    for (let i = 0; i < this.userDataService.assetInfo.participants.length; i++) {
      if (this.userDataService.assetInfo.participants[i].id != userId) {

        if (this.participants.has(this.userDataService.assetInfo.participants[i].id)) {
          console.log("user already has color", this.userDataService.assetInfo.participants[i].id, this.userDataService.assetInfo.participants[i].color);
          this.userDataService.assetInfo.participants[i].color = this.participants.get(this.userDataService.assetInfo.participants[i].id);
        } else {
          var index = (i % this.chatColors.length);
          console.log("index", index, i);
          if (index == 0) index += 1;
          this.userDataService.assetInfo.participants[i].color = this.chatColors[index];
        }
      } else {
        this.userDataService.assetInfo.participants[i].color = this.chatColors[0]; //currentUser siempre se pinta blanco
      }

      console.log("COLOR", i, this.userDataService.assetInfo.participants[i].id, this.userDataService.assetInfo.participants[i].name, this.userDataService.assetInfo.participants[i].color);

      this.participants.set(this.userDataService.assetInfo.participants[i].id, this.userDataService.assetInfo.participants[i].color!);
    }

  }

  getBackgroundColor(color: string) {
    var index = this.chatColors.findIndex(c => c == color);
    return this.chatBackgroundColors[index];
  }

  updateChat(lastMessageId: number | null, getLastChatMessage: boolean): Observable<any> {
    return new Observable(observer => {
      console.log("update chat for asset: and user id :", this.userDataService.AssetId, this.userDataService.Id);

      var userId = getLastChatMessage ? this.userDataService.Id! : null;
      var userRole = getLastChatMessage ? this.userDataService.Role! : null;

      this.apiService.getChatForAsset(this.userDataService.AssetId!, lastMessageId, userId, userRole).subscribe({
        next: (data: chatMessageResponse) => {
          console.log("Get chat for asset gets:", data);
          
          if (data != null && data.messages.length > 0) { 
            data.messages.forEach((message: chatMessageWithFile) => {
              message.chatData.date = new Date(message.chatData.date);
              this.addMessage(message.chatData);
            });
          }

          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
          console.error(error);
        }
      });
    });
  }

  groupMessagesByDate(): ChatMessage[][] {
    const groups: { [key: string]: ChatMessage[] } = {};

    console.log("GROUP MESSAGES", this.messages);
    this.messages.sort((a, b) => a.date <= b.date ? -1 : 1);

    this.messages.forEach(message => {
      //también les asigno el color (preparado para cuando sean más de dos)
      if (message.color == undefined) message.color = this.getMessageColor(message.userId);

      const dateKey = new Date(message.date).toDateString();
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(message);
    });

    return Object.values(groups);
  }

  addMessageToGroup(groups: ChatMessage[][], message: ChatMessage): ChatMessage[][] {
    const dateKey = new Date(message.date).toDateString();

    var groupIndex = groups.findIndex(gr => gr.find(m => new Date(m.date).toDateString() == dateKey));
    if (groupIndex < 0) {
      groupIndex = groups.length;
      groups.push([]);
    }

    console.log("ADD MESSAGE TO GROUP");
    if (message.color == undefined) message.color = this.getMessageColor(message.userId);

    var index = groups[groupIndex].findIndex(m => m.id == message.id);
    if (index > -1) groups[groupIndex][index] = message;
    else groups[groupIndex].push(message);

    return groups;
  }

  addMessage(mssg: ChatMessage) {
    try {
      var index = this.messages.findIndex(m => m.id == mssg.id);
      console.log(this.messages[index]);

      if (index > -1) {
        this.messages[index] = mssg;
      }
      else {
        this.messages.push(mssg);
      }
    }
    catch (err) {
      this.logger.error("AddMessage error:", err);
    }
  }

  getMessages() {
    return this.messages;
  }

  getLastMessage() {
    if (this.messages.length == 0) return null;
    return this.messages[0].id;
  }

  getMessageColor(participantId: number) {
    if (!this.participants.has(participantId)) {
      this.participants.set(participantId, this.chatColors[this.participants.size]);
    }

    return this.participants.get(participantId);
  }

  deleteMessage(data: number) {
    let oldMessages = this.messages;
    this.messages = [];
    console.log(data);
    const index = oldMessages.findIndex(o => o.id == data);
    oldMessages.splice(index, 1);
    this.messages = oldMessages;
  }

  resetMessages() {
    this.messages = [];
  }

  imageEdited(result: File) {
    this.onImageEdited.emit(result);
  }

}


